var translationKey = 'faqs.description';
var aeoutfitters = {
    drawerActionButton: {
        text: 'drawerActionButton.aeoutfittersDrawerActionButtonText',
        link: 'https://www.ae.com/us/en/myaccount/real-rewards'
    },
    certificateBalance: false,
    certificateExpirationDays: null,
    certificateValue: null,
    disclaimerTranslationKey: null,
    es: {
        termsAndConditionsLink: 'https://s7d2.scene7.com/is/content/aeo/Help/Real_Rewards_Terms_US_Final.pdf'
    },
    en: {
        termsAndConditionsLink: 'https://s7d2.scene7.com/is/content/aeo/Help/Real_Rewards_Terms_US_Final.pdf'
    },
    howToEarnPointsHeader: '',
    faqsSnapshot: true,
    isRewardTiers: false,
    isValuePropBanner: false,
    links: [],
    translationViewPrintKey: null,
    PRIVATE_LABEL: {
        actionButton: null,
        banner: 'aeoutfitters-banner.png',
        cashRewardsBalance: false,
        certificateHistoryImg: '',
        certificateHistory: false,
        earnings: {
            icons: {},
            titleKey: ''
        },
        faqs: null,
        rewardsBalance: false,
        snapshotTranslationKey: translationKey,
        translationKey: translationKey,
        valuePropImg: '',
        en: {
            propositions: []
        },
        es: {
            propositions: []
        }
    },
    DUAL_CARD: {
        actionButton: null,
        banner: 'aeoutfitters-banner.png',
        cashRewardsBalance: false,
        certificateHistoryImg: '',
        certificateHistory: false,
        earnings: {
            icons: {},
            titleKey: ''
        },
        faqs: null,
        rewardsBalance: false,
        snapshotTranslationKey: translationKey,
        translationKey: translationKey,
        valuePropImg: '',
        en: {
            propositions: []
        },
        es: {
            propositions: []
        }
    }
};
export default aeoutfitters;
